<div class="card" *ngIf="menuItem">
  <div class="tw-mb-4">
    <h5 class="tw-mb-1">
      {{ menuItem.Id ? "Edit" : "New" }} Menu Item @if(menuItem.Name){({{
      menuItem.Name
      }})}
    </h5>
    @if(business){
    <div class="tw-text-sm tw-text-gray-500">
      Restaurant: <strong>{{ business.UI?.Title || business.Name }}</strong>
    </div>
    }
  </div>
  <p-tabView>
    <p-tabPanel header="General">
      <div class="p-fluid p-formgrid tw-max-w-lg">
        <div class="field">
          <label htmlFor="name">Name</label>
          <input pInputText id="name" type="text" [(ngModel)]="menuItem.Name" />
        </div>

        <div class="field">
          <p-checkbox binary="true" name="half" label="Support Half And Half?"
            [ngModel]="menuItem.HalfAndHalfPrice != null"
            (ngModelChange)="menuItem.HalfAndHalfPrice = $event ? 0 : null"></p-checkbox>
        </div>
        <div class="field" *ngIf="menuItem.HalfAndHalfPrice != null">
          <label for="half">Extra Added Price for Half&Half</label>
          <input pInputText type="number" name="halfandhalf" [(ngModel)]="menuItem.HalfAndHalfPrice" />
        </div>
        <div class="field">
          <label for="tags">Tags</label>
          <brt-tag-selector id="tags" [(ngModel)]="menuItem.Tags" [businessId]="menuItem.BusinessId"
            [canAdd]="true"></brt-tag-selector>
        </div>
      </div>
    </p-tabPanel>

    <p-tabPanel header="Serving Hours">
      <div>
        <div class="p-formgrid grid p-fluid align-items-end"
          *ngFor="let item of menuItem.ServingHours; let index = index">
          <div class="field col-12 md:col-2">
            <label htmlFor="type">Order Type</label>
            <p-dropdown [options]="orderTypes" [(ngModel)]="item.OrderType"></p-dropdown>
          </div>
          <div class="field col-12 md:col-3">
            <label htmlFor="day">Days</label>
            <p-multiSelect [options]="weekDays" [(ngModel)]="item.Days"
              placeholder="Select days of week"></p-multiSelect>
          </div>
          <div class="field col-12 md:col-3">
            <label htmlFor="start-time">Start Time</label>
            <p-inputMask id="start-time" type="text" [(ngModel)]="item.StartTime" mask="99:99:99" placeholder="HH:MM" />
          </div>
          <div class="field col-12 md:col-3">
            <label htmlFor="end-time">End Time</label>
            <p-inputMask id="end-time" type="text" [(ngModel)]="item.EndTime" mask="99:99:99" placeholder="HH:MM" />
          </div>
          <div class="field col-12 md:col-1">
            <p-button icon="pi pi-trash" severity="danger" [rounded]="true"
              (click)="menuItem.ServingHours.splice(index, 1)"></p-button>
          </div>
        </div>
        <p-button label="Add new serving time" icon="pi pi-plus" severity="success"
          (click)="menuItem.ServingHours.push({})"></p-button>
      </div>
    </p-tabPanel>

    <p-tabPanel header="Base Prices">
      <div>
        <h6>Prices by order type</h6>
        <div class="p-formgrid grid p-fluid align-items-end tw-max-w-lg"
          *ngFor="let item of menuItem.BasePrice; let index = index">
          <div class="field col-12 md:col-5">
            <label htmlFor="type">Order Type</label>
            <p-dropdown id="type" [options]="orderTypes" [(ngModel)]="item.OrderType"></p-dropdown>
          </div>
          <div class="field col-12 md:col-5">
            <label htmlFor="price">Price</label>
            <input pInputText type="number" [(ngModel)]="item.Price" />
          </div>
          <div class="field col-12 md:col-2">
            <p-button icon="pi pi-trash" severity="danger" [text]="true"
              (click)="menuItem.BasePrice.splice(index, 1)"></p-button>
          </div>
        </div>
        <p-button label="Add new order type price" icon="pi pi-plus" severity="success"
          (click)="menuItem.BasePrice.push({})" size="small" [outlined]="true"></p-button>
      </div>
      <hr />
      <div>
        <h6>Extra added price by order source</h6>
        <div class="p-formgrid grid p-fluid align-items-end tw-max-w-lg"
          *ngFor="let item of menuItem.SourcePrice; let index = index">
          <div class="field col-12 md:col-5">
            <label htmlFor="type">Order Source</label>
            <p-dropdown [options]="orderSources" [(ngModel)]="item.Source"></p-dropdown>
          </div>
          <div class="field col-12 md:col-5">
            <label htmlFor="price">Extra Price</label>
            <input pInputText type="number" [(ngModel)]="item.Price" />
          </div>
          <div class="field col-12 md:col-2">
            <p-button icon="pi pi-trash" severity="danger" [text]="true"
              (click)="menuItem.SourcePrice.splice(index, 1)"></p-button>
          </div>
        </div>
        <p-button label="Add new source price" icon="pi pi-plus" severity="success"
          (click)="menuItem.SourcePrice.push({})" size="small" [outlined]="true"></p-button>
      </div>
    </p-tabPanel>

    <p-tabPanel header="Options">
      <brt-menu-item-option [(ngModel)]="menuItem.Options"></brt-menu-item-option>
    </p-tabPanel>

    <p-tabPanel header="UI Settings">
      <brt-ui-settings id="ui" [(ngModel)]="menuItem.UI" [business-id]="businessId" [keys]="[
          'Image:image:ai:menu-item-image:' + menuItemId,
          'Description:text:ai:menu-item-description:' + menuItemId
        ]">
      </brt-ui-settings>
    </p-tabPanel>
  </p-tabView>
  <div class="tw-flex tw-gap-2 tw-sticky tw-z-10 tw-bottom-0 tw-bg-white tw-p-2">
    <button pButton pRipple label="Save" (click)="save()"></button>
    <button *ngIf="menuItem.Id" pButton pRipple label="Apply" class="p-button-secondary" (click)="save(false)"></button>
  </div>
</div>